import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHourglassEmpty = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.5385 4C15.9633 4 16.3077 3.66422 16.3077 3.25V2.75C16.3077 2.33578 15.9633 2 15.5385 2H4.76923C4.34439 2 4 2.33578 4 2.75V3.25C4 3.66422 4.34439 4 4.76923 4C4.76923 6.84266 6.40436 9.24169 8.64237 10C6.40436 10.7583 4.76923 13.1573 4.76923 16C4.34439 16 4 16.3358 4 16.75V17.25C4 17.6642 4.34439 18 4.76923 18H15.5385C15.9633 18 16.3077 17.6642 16.3077 17.25V16.75C16.3077 16.3358 15.9633 16 15.5385 16C15.5385 13.1573 13.9033 10.7583 11.6653 10C13.9033 9.24169 15.5385 6.84266 15.5385 4ZM10.1538 8.5C8.3017 8.5 6.82051 6.42131 6.82051 4H13.4872C13.4872 6.43578 11.9965 8.5 10.1538 8.5Z",
		fill: "#0D2976"
	})
});
export default SvgHourglassEmpty;
